import { Koukyuu } from "@/types/Shinsei";
import { reactive } from "vue";

export function useInit() {
  const koukyuu: Koukyuu = reactive({
    user_id: null,
    koukyuuList: [{
      koukyuu_date: null,
      koukyuu_tani_type: null,
      koyou_keiyaku_id: null,
      mst_syuugyou_basyo_id: null
    }] ,
  });

  return {
    koukyuu,
  }
}
